
import { Component, Vue } from 'vue-property-decorator';

const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  seeding_type: `${FCAPI}/boss/hundun/chuang/seeding/type`
};

@Component
export default class MissionDetail extends Vue {
  is_loading = false;
  data_list = [];
  pagenation_info = { current: 0, limit: 0, total: 0 };
  visible = false;
  title = '新增分类';
  more_form: any;
  select_id = 0; // 编辑按钮id
  dialog_type = 1; // 弹窗类型 1=新增，2=编辑

  async getList(page = 1) {
    this.is_loading = true;
    const res = await this.$axios.get(API.seeding_type, { params: { current: page, limit: 20 } });
    if (res.status !== 200 && res.data.status !== 200) return this.$message.error('数据获取失败！');
    this.pagenation_info = { current: res.data.data.current, limit: res.data.data.limit, total: res.data.data.total };
    this.data_list = res.data.data.detail;
    this.is_loading = false;
  }
  paginationOption() {
    return {
      current: this.pagenation_info.current || 0,
      total: this.pagenation_info.total || 0,
      pageSize: this.pagenation_info.limit || 0,
      showTotal: () => `共${this.pagenation_info.total}条，每页${this.pagenation_info.limit}条`
    };
  }
  //翻页
  changePage(page: any) {
    this.getList(page.current);
  }
  addBtn() {
    this.visible = true;
    this.title = '新增分类';
    this.dialog_type = 1;
  }
  editBtn(val: any) {
    this.visible = true;
    this.title = '编辑分类';
    this.dialog_type = 2;
    this.select_id = val.id;
    this.$nextTick(() => {
      this.more_form.setFieldsValue({
        name: val.name,
        description: val.description
      });
    });
  }
  async deleteData(val: number) {
    const res = await this.$axios.delete(API.seeding_type + '/' + val);
    if (res.status != 200 && res.data.status != 200) return this.$message.error('删除失败！');
    this.getList();
  }
  deleteBtn(val: any) {
    this.$confirm({
      title: '删除确认?',
      content: '您确认要删除所选数据？',
      onOk: () => {
        this.deleteData(val.id);
      }
    });
  }
  handleOk() {
    this.more_form.validateFields(async (err: any, values: any) => {
      if (!err) {
        const send_data = {
          name: values.name,
          description: values.description
        };
        const res = this.dialog_type == 1 ? await this.$axios.post(API.seeding_type, send_data) : await this.$axios.put(API.seeding_type + '/' + this.select_id, send_data);
        this.visible = false;
        if (res.data.status !== 200) return this.$message.error('编辑失败');
        this.$message.success(this.dialog_type == 1 ? '新增成功' : '编辑成功');
        this.getList();
        this.more_form.resetFields();
      }
    });
  }
  handleCancel() {
    this.visible = false;
    this.more_form.resetFields();
  }
  beforeCreate() {
    this.more_form = this.$form.createForm(this, { name: 'dynamic_rule' });
  }
  created() {
    this.getList();
  }
}
